export const REQUEST_CURRENT_STATUSES = {
    'LM check': 'lending-manager-check',
    'FC check': 'financial-controller-check',
}
